<template>
  <div>
    <!-- 没有签章状态、获取为撤回状态  发起签章-->
    <el-button
      v-if="showESignBtn"
      :type="type"
      plain
      @click="() => (isSigner ? electronSign() : addESignTask())"
    >
      在线签章
    </el-button>

    <!--待签章状态，可撤回-->
    <el-button
      v-if="
        signatureStatus === signatureStatusDict.TO_BE_SIGNED.value && !isSigner
      "
      :type="type"
      class="m-r-8"
      plain
      @click="backESignTask"
    >
      撤回签章
    </el-button>

    <!--签章状态时，展示的提示信息-->
    <el-tooltip
      v-if="signatureInstructionText"
      :content="signatureInstructionText"
      placement="top"
    >
      <i class="el-icon-info text-info"></i>
    </el-tooltip>

    <!--签章中状态时，如果当前登录人就是签章人，则展示继续签章-->
    <template
      v-if="
        signatureStatus === signatureStatusDict.SIGNING.value &&
          signatureInfo.signer === employeeId
      "
    >
      <el-button :type="type" plain @click="continueToSign">
        继续签章
      </el-button>
      <el-button :type="type" plain @click="signerCancelESign">
        取消签章
      </el-button>
    </template>

    <!--拒绝理由-->
    <el-button
      v-if="signatureStatus === signatureStatusDict.REJECTED.value"
      type="text"
      class="m-l-16"
      @click="showRejectionReason"
    >
      拒绝理由
    </el-button>

    <!--已签章，点击后重新发起签章-->
    <el-button
      v-if="
        signatureStatus === signatureStatusDict.SIGNED.value ||
          signatureStatus === signatureStatusDict.REJECTED.value
      "
      :type="type"
      plain
      @click="reESignTask"
    >
      重新签章
    </el-button>

    <signature-preview-dialog
      :dialog-visible.sync="signaturePreviewVisible"
      :file-url="signFileUrl"
      :file-name="signFileName"
      :task-id="ESignTaskId"
      :task-desc="taskDesc"
      :attachment-id="attachmentId"
      :preview-attachment-id="previewAttachmentId"
      :before-signature-fun="beforeSignatureFun"
      @closeSignatureWindow="$emit('refresh')"
    />

    <!--loading-->
    <a-modal v-model="loading" :footer="null" :closable="false">
      <div>
        <a-spin class="m-r-14" />
        文件正在转成PDF签章格式，请稍后….
      </div>
    </a-modal>
  </div>
</template>

<script>
// 组件
import SignaturePreviewDialog from '@/components/common/signature/SignaturePreviewDialog'

// 数据字典
import { signatureStatusDict } from '@/dictionary/signature'

// 工具函数
import { mapState } from 'vuex'

// 引入后端接口
import {
  htmlToPdfApi,
  getFileListByFileIdsApi,
  attachmentToPdfApi,
  getAttachmentToPdfStatusApi
} from '@/api/up-file'
import {
  getSignatureOpenStatusApi,
  getSignatureRemainingCountApi,
  getAllSignerInfoApi,
  backESignTaskApi,
  unlockESignTaskApi,
  getESignFileUrlByRightApi
} from '@/api/signature'
import { getFileUrlByFileIdApi } from '@/api/up-file'

export default {
  name: 'SignatureFilePrepare',

  components: {
    SignaturePreviewDialog
  },

  props: {
    tipText: {
      type: String,
      default: '确定在线签章吗？'
    },

    // 附件id，优先级高于htmlTemplate
    fileId: {
      type: [String, Number],
      default: ''
    },

    // 任务描述 -- 用于在签章任务列表中查看到关于任务的一些信息，（一般情况下传项目名称）
    taskDesc: {
      type: String,
      default: ''
    },

    // 发起签章任务后的任务id
    taskId: {
      type: [String, Number],
      default: ''
    },

    //  html字符串，若传有fileId，则改字段会被忽略
    htmlObject: {
      type: Object,
      default: () => {}
    },

    // 动态获取html字符串；若传有fileId，则该字段会被忽略
    getHtmlTemplate: {
      type: Function,
      default: () => Promise.resolve('')
    },

    // 当前的签章状态
    signatureStatus: {
      type: [Number, String],
      default: ''
    },

    // button的type 同 el-button
    type: {
      type: String,
      default: 'primary'
    },

    // 签章的拒绝理由
    // 'signer': '', 'rejectionReason': '', 'rejectionTime': ''
    signatureInfo: {
      type: Object,
      default: () => {}
    },

    /**
     * 在发起签章前的校验函数
     */
    beforeSignatureValidFun: {
      type: Function,
      default: () => true
    },

    /**
     * 拥有签章权限人在正式开始签章前，需要进行处理的操作函数
     * 也可以作为没有签章权限人，发起签章任务成功的处理函数
     */
    beforeSignatureFun: {
      type: Function,
      default: fileId => Promise.resolve()
    },

    /**
     * 如果需要鉴权，则传入获取文件地址的函数
     */
    getFileUrlFun: {
      type: Function,
      default: attachmentId => getFileUrlByFileIdApi({ attachmentId })
    }
  },

  data() {
    return {
      // 数据字典
      signatureStatusDict,

      htmlData: {},

      // 签章变量
      signaturePreviewVisible: false,
      signFileUrl: '',
      signFileName: '',
      attachmentId: '',
      previewAttachmentId: '',

      // 不同签章文字的提示文字
      signatureInstructionText: '',

      // visible
      loading: false
    }
  },

  computed: {
    ...mapState('user', ['isSigner', 'employeeId']),

    htmlTemplate: {
      get() {
        return Object.assign({}, this.htmlObject, this.htmlData)
      },
      set(val) {
        this.htmlData = val
      }
    },

    // 展示在线签章按钮
    showESignBtn() {
      if (this.isSigner) {
        return (
          !this.signatureStatus ||
          this.signatureStatus === signatureStatusDict.BACK.value ||
          this.signatureStatus === signatureStatusDict.TO_BE_SIGNED.value
        )
      } else {
        return (
          !this.signatureStatus ||
          this.signatureStatus === signatureStatusDict.BACK.value
        )
      }
    },

    // 当前的签章任务Id
    ESignTaskId() {
      if (
        this.signatureInfo.signStatus ===
          signatureStatusDict.TO_BE_SIGNED.value ||
        this.signatureInfo.signStatus === signatureStatusDict.SIGNING.value
      ) {
        return this.taskId || this.signatureInfo.taskId
      } else {
        return ''
      }
    }
  },

  watch: {
    signatureStatus: {
      handler: function(val) {
        this.signatureInstructionText = ''
        this.getSignatureInstruction(val)
      },
      immediate: true
    }
  },

  methods: {
    /* ----------------------------------- 不同状态需要展示的信息函数 ----------------------------------- */
    /**
     * 不同签章状态，获取签章说明文字
     */
    getSignatureInstruction(status) {
      // 如果任务发起的人有签章权限，则不做任何提示
      if (this.isSigner) return

      // 未签章时，展示的提示问题
      if (status === signatureStatusDict.TO_BE_SIGNED.value) {
        getAllSignerInfoApi()
          .then(res => {
            const employeeNameList =
              (res?.data || []).map(value => value.employeeName).join('、') ||
              '-'
            this.signatureInstructionText = `已将签章申请发送给签章人员：${employeeNameList}`
          })
          .catch(() => {})
      }

      // 签章中且签章人不为当前登录人，展示的提示文字
      if (
        status === signatureStatusDict.SIGNING.value &&
        this.signatureInfo?.signerName
      ) {
        this.signatureInstructionText = `由${this.signatureInfo.signerName}签章锁定中`
      }
    },

    /* ----------------------------------- 新增签章任务前的校验工作 -------------------------- */
    /**
     * 判断公司是否开通了在线签章
     */
    getSignatureOpenStatus() {
      return new Promise((resolve, reject) => {
        getSignatureOpenStatusApi()
          .then(res => {
            if (!res.data) {
              reject()
              this.$alert(
                '当前登录企业未开通在线签章，请联系管理员开通',
                '系统提示',
                {
                  confirmButtonText: '关 闭'
                }
              )
            } else {
              this.$systemConfirm(this.tipText, '系统提示').then(result => {
                if (result) resolve()
                else reject()
              })
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /**
     * 判断登录员工是否有签章权限
     */
    judgeEmployeeSignatureRight() {
      return new Promise((resolve, reject) => {
        if (this.isSigner) {
          resolve(true)
        } else {
          getAllSignerInfoApi()
            .then(res => {
              const employeeList = res.data

              const employeeNameList =
                employeeList.map(value => value.employeeName).join('、') || '-'

              const html = `<div>您还不是签章人员，无签章权限。点击下方按钮，系统会把签章申请发送给签章人员进行签章，签章完成后，系统会将签章文件返回到此处。</div>
<div style="font-size: 12px; color: #999; margin-top: 10px">也可以联系管理员，将您添加为签章人员</div>
<div style="background:#f5f5f5; padding:4px 6px; margin-top: 16px; margin-bottom: 40px">当前企业签章人员：<span class="color:#999">${employeeNameList}</span></div>`
              this.$confirm(html, '系统提示', {
                confirmButtonText: '发送给签章人员',
                cancelButtonText: '取 消',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                customClass: 'no-right-confirm',
                closeOnClickModal: false
              })
                .then(() => {
                  resolve(false)
                })
                .catch(() => {
                  reject()
                })
            })
            .catch(err => {
              reject()
            })
        }
      })
    },

    /**
     * 获取公司签章次数，若没有次数则进行提示；有次数再继续往下走
     */
    getSignatureRemainingCount() {
      return new Promise((resolve, reject) => {
        getSignatureRemainingCountApi()
          .then(res => {
            if (!res.data) {
              reject()
              this.$systemConfirm(
                '当前企业剩余签章次数为0，请先购买签章次数',
                '系统提示',
                '立即购买'
              ).then(result => {
                if (result) {
                  this.$router.push({ name: 'SignatureBuy' })
                }
              })
            } else {
              resolve()
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /**
     * 整体的校验函数
     */
    async judgeValidate() {
      try {
        // 判断企业是否开通在线签章服务
        await this.getSignatureOpenStatus()
        const hasRight = await this.judgeEmployeeSignatureRight()
        if (!hasRight) return true

        // 有权限则继续判断剩余签章次数
        await this.getSignatureRemainingCount()
        return true
      } catch (e) {
        return false
      }
    },

    /* ----------------------------------- 新增签章前准备好pdf文件id -------------------------- */
    /**
     * 传入的为htmlTemplate时，将html转换成pdf
     */
    htmlToPdf(name, content, platform) {
      return new Promise((resolve, reject) => {
        htmlToPdfApi({
          name,
          content,
          platform,
          authorization: 1
        })
          .then(res => {
            resolve({ attachmentId: res.data })
          })
          .catch(err => {
            reject({ message: err?.message || '转换pdf失败' })
          })
      })
    },

    /**
     * 通过传入的文件名，解析出文件的格式
     * @param {string} fileName 传入的文件名
     * @returns {string} 文件类型
     */
    getFileTypeByFileName(fileName) {
      if (fileName && fileName.indexOf('.') > -1) {
        const fileType = fileName.split('.')[fileName.split('.').length - 1]
        return fileType.toLowerCase()
      }
    },

    /**
     * 传入id时，先获取fileId对应的附件信息
     */
    getFileInfo(fileId) {
      return new Promise((resolve, reject) => {
        getFileListByFileIdsApi({ attachmentId: fileId })
          .then(res => {
            const temp = res.data[0] || {}

            // 如果附件不是pdf类型时，需要转换成pdf类型再进行签章
            if (
              this.getFileTypeByFileName(temp.attachmentInfo.fileName) === 'pdf'
            ) {
              resolve({ attachmentId: fileId })
              return
            }

            attachmentToPdfApi(fileId)
              .then(() => {
                const loop = () => {
                  getAttachmentToPdfStatusApi(fileId)
                    .then(res => {
                      if (!res.data?.resultAttachmentId) {
                        setTimeout(() => loop(), 1000)
                        return
                      }

                      resolve({
                        attachmentId: fileId,
                        pdfId: res.data.resultAttachmentId
                      })
                    })
                    .catch(() => {
                      setTimeout(() => loop(), 1000)
                    })
                }

                loop()
              })
              .catch(err => {
                reject(err)
              })
          })
          .catch(err => {
            reject({ message: err?.message || '获取附件信息失败' })
          })
      })
    },

    /**
     * 新增签章任务
     */
    async addESignTask(id) {
      // 清除htmlData的缓存
      this.htmlData = {}

      try {
        // 签章前先校验是否可以进行签章
        if (!this.beforeSignatureValidFun()) return

        // 判断前置条件，是否可以开始签章任务生成逻辑
        if (!(await this.judgeValidate())) return

        this.loading = true
        const fileId = this.fileId || id

        // 当fileId和htmlTemplate都不存在的情况下
        if (!(fileId || this.htmlTemplate?.template || fileId)) {
          this.htmlTemplate = await this.getHtmlTemplate()
        }

        // 签章逻辑，先生成pdf的fileId，再发起签章任务
        let beforeAddESignTask = Promise.resolve()

        if (fileId) {
          beforeAddESignTask = this.getFileInfo(fileId)
        } else if (this.htmlTemplate) {
          beforeAddESignTask = this.htmlToPdf(
            this.htmlTemplate.fileName,
            this.htmlTemplate.template,
            1
          )
        }

        beforeAddESignTask
          .then(({ attachmentId, pdfId }) => {
            const id = pdfId || attachmentId
            this.attachmentId = attachmentId
            this.previewAttachmentId = id

            this.getFileUrlFun(id)
              .then(res => {
                console.log('res', res)
                this.signFileUrl = res?.data?.external || res?.data || res || ''
                this.signFileName =
                  res?.data?.attachmentName ||
                  this.signatureInfo.fileName ||
                  this.htmlTemplate.fileName
                this.signaturePreviewVisible = true
              })
              .catch(err => {
                this.$message.error(err?.message || '签章文件地址获取失败')
              })
          })
          .catch(err => {
            this.$message.error(err?.message)
          })
          .finally(() => {
            this.loading = false
            // this.htmlTemplate = {}
          })
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    },

    /**
     * 拥有签章权限的人，因为两种状态都是待签章，所以在发起签章前需要先撤回签章
     */
    electronSign() {
      if (
        !this.ESignTaskId ||
        this.signatureStatus === signatureStatusDict.BACK.value
      ) {
        this.addESignTask()
        return
      }

      backESignTaskApi(this.ESignTaskId)
        .then(res => {
          this.addESignTask(this.fileId || this.signatureInfo?.fileId)
        })
        .catch(err => {
          this.$message.error('在线签章发起失败')
        })
    },

    /**
     * 重新发起签章任务
     */
    reESignTask() {
      this.$systemConfirm('确定以当前报价单信息签章吗', '系统提示').then(
        result => {
          if (!result) return

          this.addESignTask()
        }
      )
    },

    /**
     * 签章撤回 没有签章权限的人 在待签章状态 进行签章任务的撤回
     */
    backESignTask() {
      this.$systemConfirm('确定撤回签章任务？', '系统提示').then(result => {
        if (!result) return

        backESignTaskApi(this.ESignTaskId)
          .then(res => {
            this.$emit('refresh')
          })
          .catch(err => {
            this.$message.error(err?.message || '签章任务撤回失败')
          })
      })
    },

    /**
     * 继续签章
     */
    async continueToSign() {
      this.attachmentId = this.signatureInfo.fileId

      // 如果文件类型不为pdf，则先查询到其对应的pdf文件
      if (this.getFileTypeByFileName(this.signatureInfo.fileName) !== 'pdf') {
        const { data = {} } = await getAttachmentToPdfStatusApi(
          this.attachmentId
        )
        this.previewAttachmentId = data.resultAttachmentId
      }

      getESignFileUrlByRightApi({ taskId: this.ESignTaskId })
        .then(file => {
          this.signFileUrl = file.data || ''
          this.signFileName =
            file?.data?.attachmentName || this.signatureInfo.fileName || ''
          this.signaturePreviewVisible = true
        })
        .catch(err => {
          this.$message.error(err?.message || '签章文件地址获取失败')
        })
    },

    /**
     * 在线签章人 在 签章中状态时，取消签章（包含取消绑定和撤回两个步骤）
     */
    signerCancelESign() {
      if (
        this.signatureStatus !== signatureStatusDict.SIGNING.value ||
        this.signatureInfo.signer !== this.employeeId
      ) {
        return
      }

      this.$systemConfirm('确定取消签章吗？', '系统提示').then(result => {
        if (!result) return

        unlockESignTaskApi(this.ESignTaskId)
          .then(res => {
            backESignTaskApi(this.ESignTaskId)
              .then(res => {
                this.$emit('refresh')
              })
              .catch(err => {
                this.$message.error(err?.message || '签章任务取消失败')
              })
          })
          .catch(err => {
            this.$message.error(err?.message || '签章任务取消失败')
          })
      })
    },

    /**
     * 展示拒绝理由
     */
    showRejectionReason() {
      this.$alert(
        `<p>签章人：${this.signatureInfo.signerName ||
          '-'}</p><p>拒绝时间：${this.signatureInfo.signatureTime ||
          '-'}</p><p>拒绝理由：${this.signatureInfo.refuseReason || '-'}</p>`,
        '拒绝理由',
        {
          dangerouslyUseHTMLString: true
        }
      ).then(res => {})
    }
  }
}
</script>

<style lang="scss">
.no-right-confirm {
  width: 570px !important;
}
</style>
